import { FEATURE_FLAGS, VARIANT_KEYS } from "src/constants/featureFlags";
import { useFeatureFlag } from "./useFeatureFlag";

export const useSwipeAppointmentCalendar = () => {
  const { value } = useFeatureFlag(FEATURE_FLAGS.MOBILE_APPOINTMENT_CALENDAR);

  return value === VARIANT_KEYS.TEST
};
